import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { InstacartManagedReportsListPageAccessControl } from './pages/instacart-managed-reports-list/InstacartManagedReportsListPage.configuration'
import { TransactionLogsListPageAccessControl } from './pages/transaction-logs-list/TransactionLogsListPage.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'reports',
  routes,
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'reports-dashboard-tool',
  },
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {},
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.AnalyticsReportsAndLogs,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'View Instacart managed reports and analytics',
          labelId: 'reportsDomain.instacartManagedReportsList.nav',
          route: 'instacart-managed-reports-list',
          accessControl: InstacartManagedReportsListPageAccessControl,
          position: 2,
        },
        {
          type: 'item',
          llmDescription:
            'View transaction logs, payment activity, and financial reconciliation records for auditing',
          labelId: 'reportsDomain.transactionLogsList.nav',
          route: 'transaction-logs-list',
          accessControl: TransactionLogsListPageAccessControl,
          position: 4,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
